const closeButtonLabel = "Затвори";
const bgBG = {
  closeButtonLabel
};
export {
  closeButtonLabel,
  bgBG as default
};
